
import Link from "next/link";
import { useInstructor } from "@/hooks/useInstructor";

const InstructorTools = ({ userId }) => {
  const { instructorData, isLoading } = useInstructor(userId, 'instructor');
  
  return (
    <>
    </>
  );
};

export default InstructorTools;